import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { DateTime } from 'luxon';
import useLearnMoreDialog from 'react-components/dialog-forms/hooks/useLearnMoreDialog';
import { Goal } from 'stories/containers/GoalsTracking/types';
import { timeFormatter } from '@act/shared/utilities';

import './AssignedSurveyHospitalizationSummary.scss';
import { Typography } from '@mui/material';
import { IconLibrary } from '@act/storybook';

export const AssignedSurveyHospitalizationSummary = ({
  goal,
}: {
  goal: Goal;
}) => {
  const openLearnMoreDialog = useLearnMoreDialog();
  if (goal.goalType !== 'survey') {
    return null;
  }

  const survey = goal as SurveyV2.AssignedSurveyDto;

  return (
    <div className="assigned-survey-hospitalization-summary">
      <Typography variant="labelMedium" fontWeight="bold" component="h3">
        Events Included:
      </Typography>
      <hr />
      {survey.hospitalizations.map(hospitalization => {
        const dateString = hospitalization.dischargeDate;

        if (!dateString) {
          return null;
        }

        const date = DateTime.fromFormat(dateString, 'yyyy-MM-dd').toMillis();

        const text = `Hospitalization Event | ${timeFormatter.epochToHumanReadableDate(
          {
            date,
            showFullMonthName: true,
            excludeRelativeDay: true,
          }
        )}`;

        return (
          <a
            key={hospitalization.id}
            href="#"
            role="button"
            onClick={() =>
              openLearnMoreDialog({
                hospitalization: hospitalization,
                learnMoreContent: survey?.survey?.learnMoreContent,
              })
            }
          >
            {text}
            {!hospitalization.isAssumed && <IconLibrary iconName="SealCheck" />}
          </a>
        );
      })}
    </div>
  );
};
